var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { map, } from 'rxjs/operators';
import { forEach, get, chain, cloneDeep } from 'lodash';
import { HeaderService, HelpersService, UserService } from '@base/shared/services';
import { RouterParams } from '@eyrus/shared/services';
import { combineLatest } from 'rxjs';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
var BreadcrumbsComponent = /** @class */ (function () {
    function BreadcrumbsComponent(router, route, headerService, routerParams, helpers, account, translate) {
        this.router = router;
        this.route = route;
        this.headerService = headerService;
        this.routerParams = routerParams;
        this.helpers = helpers;
        this.account = account;
        this.translate = translate;
        this.breadcrumbs = [];
        this.activeRoute = {};
        this.paramsData = {};
        this.subscriptions = {};
    }
    BreadcrumbsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _params = this.routerParams.params;
        var _breadcrumbs = this.headerService.breadcrumbsListener;
        this.subscriptions.breadcrumbs = combineLatest(_params, _breadcrumbs)
            .pipe(map(function (_a) {
            var params = _a[0], breadcrumbs = _a[1];
            // combineLatest returns an array of values, here we map those values to an object
            return __assign({}, params, breadcrumbs);
        }))
            .subscribe(function (res) {
            _this.paramsData = res;
            _this.listenChanges(res);
        });
    };
    BreadcrumbsComponent.prototype.ngOnDestroy = function () {
        forEach(this.subscriptions, function (value) { return value.unsubscribe(); });
    };
    /**
     * Navigate to selected breadcrumb
     * @param item Selected breadcrumb
     * @param current A boolean to indicate if is current active tab
     */
    BreadcrumbsComponent.prototype.openBreadCrumb = function (item, current) {
        if (current)
            return;
        if (item.url)
            return this.router.navigate([item.url]);
        var url = this.makePath(item.path);
        var queryParams = item.params ? item.params : {};
        this.router.navigate([url], {
            queryParamsHandling: 'preserve',
            queryParams: __assign({}, queryParams)
        });
    };
    /**
     * Create a new url to navigate to
     * @param path new path
     */
    BreadcrumbsComponent.prototype.makePath = function (path) {
        var _this = this;
        var newPath = path;
        var replaceItems = chain(path.split('/'))
            .map(function (item) {
            var _label = item.replace(':', '');
            var data = {
                label: item,
                value: _this.activeRoute[_label]
            };
            return item.startsWith(':') ? data : null;
        })
            .filter(function (item) { return item; })
            .value();
        replaceItems.forEach(function (item) {
            newPath = newPath.replace(item.label, item.value);
        });
        return newPath;
    };
    /**
     * Listen to new changes
     * @param event data event
     */
    BreadcrumbsComponent.prototype.listenChanges = function (event) {
        this.activeRoute = event;
        this.makeBreadCrumbs(get(cloneDeep(event), 'breadcrumbs') || []);
    };
    /**
     * Format breadcrumbs labels
     * @param data array of breadcrumbs
     */
    BreadcrumbsComponent.prototype.makeBreadCrumbs = function (data) {
        var _this = this;
        var _breadcrumbs = chain(data)
            .map(function (breadcrumb) {
            if (!breadcrumb.label.startsWith(':'))
                return breadcrumb;
            if (breadcrumb.label.toLowerCase().indexOf('date') !== -1) {
                var _label = _this.paramsData[breadcrumb.label.replace(':', '')];
                breadcrumb.label = moment(_label, ['YYYY-MM-DD', 'YYYY-MM-DD HH:mm'])
                    .locale(_this.helpers.getLang())
                    .format('dddd, MMM DD YYYY');
            }
            if (breadcrumb.label.toLowerCase().indexOf('readerserial') !== -1) {
                var _label = _this.activeRoute.typeOfView;
                breadcrumb.label = _label;
            }
            if (breadcrumb.label.toLowerCase().indexOf('projectname') !== -1) {
                var _label = get(_this.account.account, 'project.projectName') || '--';
                breadcrumb.label = _label;
            }
            if (breadcrumb.label.toLowerCase().indexOf('companyname') !== -1) {
                var _label = get(_this.account.account, 'contract.company.companyName') || '--';
                breadcrumb.label = _label;
            }
            if (breadcrumb.label.toLowerCase().indexOf('walkthroughname') !== -1) {
                var _label = get(_this.account.account, 'contractWalkthrough.walkthroughName') || '--';
                breadcrumb.label = _label;
            }
            if (breadcrumb.label.toLowerCase().indexOf('queryparams') !== -1) {
                var params = breadcrumb.label.split(':').filter(function (item) { return item.length; });
                var _label = _this.route.snapshot[params[0]][params[1]];
                if (_label)
                    breadcrumb.label = "common." + _label;
                else
                    breadcrumb.label = 'empty';
            }
            return breadcrumb;
        })
            .value();
        this.breadcrumbs = _breadcrumbs;
        this.makeTitle();
    };
    BreadcrumbsComponent.prototype.makeTitle = function () {
        var _this = this;
        var title = chain(this.breadcrumbs)
            .filter(function (item) { return item.inTitle; })
            .map(function (item) { return _this.translate.instant(item.label); })
            .join(' - ')
            .value();
        if (title)
            this.headerService.tabTitleSet.next(title);
    };
    return BreadcrumbsComponent;
}());
export { BreadcrumbsComponent };
